import { dayjs } from "@outschool/time";

function createScriptElement(id: string, src: string): HTMLScriptElement {
  const el = document.createElement("script");

  el.id = id;
  el.src = src;
  el.type = "text/javascript";
  el.async = true;

  return el;
}

export function injectScript(
  id: string,
  src: string,
  onLoad: (arg0: any) => void,
): Promise<boolean> {
  return new Promise((resolve, reject) => {
    try {
      if (typeof window !== "undefined" && document.getElementById(id)) {
        resolve(true);
        return;
      }

      const el = createScriptElement(id, src);

      el.onload = (...args) => {
        onLoad(...args);
        resolve(true);
      };

      el.onerror = () => {
        reject(new Error(`failed to add script with src: ${src}`));
      };

      document.body.appendChild(el);
    } catch (error) {
      reject(error);
    }
  });
}

/**
 * Inject an image to the document WITHOUT a src.
 * The src is expected to be set when the track action is executed.
 *
 * @param {string} id of the <img> tag.
 */
export function injectImg(id: string) {
  const img = document.createElement("img");

  img.setAttribute("id", id);
  img.setAttribute("alt", "");
  img.setAttribute("width", "1");
  img.setAttribute("height", "1");
  img.setAttribute("border", "0");
  document.body.appendChild(img);
}

/*
 * Need to remove this function after Feb 1st 2026
 */
export function isFebPromo() {
  const currentEstTime = dayjs().tz("America/New_York");
  const estFebPromoDate = dayjs("2026-02-01 00:00:00").tz(
    "America/New_York",
    true,
  );
  return currentEstTime.isAfter(estFebPromoDate);
}
